import {$authHost} from "./index";
import {API_ENDPOINTS} from "../utils/urls";


export async function payeesGetApi() {
    try {
        return await $authHost.get(API_ENDPOINTS.PAYEE);
    } catch (error: any) {
        return error;
    }
}

export async function payeeCreateApi(data: any) {
    try {
        return await $authHost.post(API_ENDPOINTS.PAYEE, data);
    } catch (error: any) {
        return error;
    }
}

export async function payeeUpdateApi(id: number | string, data: any) {
    try {
        return await $authHost.put(API_ENDPOINTS.PAYEE + `/${id}`, data);
    } catch (error: any) {
        return error;
    }
}

export async function payeeDeleteApi(id: number | string) {
    try {
        return await $authHost.delete(API_ENDPOINTS.PAYEE + `/${id}`);
    } catch (error: any) {
        return error;
    }
}

export async function payeeSetDefaultApi(id: number | string) {
    try {
        return await $authHost.put(API_ENDPOINTS.PAYEE + `/${id}/default`);
    } catch (error: any) {
        return error;
    }
}

export async function payeeUploadImageApi(id: number | string, kind: 'logo' | 'stamp' | 'sign', file: File) {
    try {
        const form = new FormData();
        form.append('img', file);
        // Let axios set multipart/form-data + boundary from the FormData itself.
        return await $authHost.put(API_ENDPOINTS.PAYEE + `/${id}/${kind}`, form);
    } catch (error: any) {
        return error;
    }
}
